(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').trim();
  const init = () => document.querySelectorAll('[data-sur-directory]').forEach(root => {
    if (root.dataset.surReady) return;
    const groups = [...root.querySelectorAll('[data-sur-directory-group]')].map(group => ({
      element: group, heading: normalize(group.querySelector('h2').textContent),
      cards: [...group.querySelectorAll('.sur-card')].map(card => ({element: card, text: normalize(card.textContent)}))
    }));
    const cards = groups.flatMap(group => group.cards);
    if (!cards.length) return;
    const controls = document.createElement('div'); controls.className = 'sur-directory-controls';
    const label = document.createElement('label'); label.htmlFor = 'sur-directory-query'; label.textContent = root.dataset.surDirectory === 'brands' ? 'Encuentra una marca' : 'Busca una categoría o departamento';
    const input = document.createElement('input'); input.id = label.htmlFor; input.type = 'search'; input.autocomplete = 'off'; input.placeholder = root.dataset.surDirectory === 'brands' ? 'Escribe una marca, por ejemplo Twinings' : 'Escribe un producto, por ejemplo café';
    const clear = document.createElement('button'); clear.type = 'button'; clear.textContent = 'Mostrar todo';
    const status = document.createElement('p'); status.id = 'sur-directory-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); input.setAttribute('aria-describedby', status.id);
    const empty = document.createElement('p'); empty.hidden = true; empty.append(document.createTextNode('No hay coincidencias en este directorio. '));
    const search = document.createElement('a'); search.textContent = 'Buscar productos en la tienda'; empty.append(search);
    const isCategory = root.dataset.surDirectory !== 'brands';
    const total = cards.length + (isCategory ? groups.length : 0);
    const totalText = isCategory ? ' categorías y departamentos' : ' marcas';
    const update = () => {
      const query = normalize(input.value); let count = 0;
      groups.forEach(group => {
        let visible = 0;
        const headingMatch = !query || group.heading.includes(query);
        if (isCategory && headingMatch) count++;
        group.cards.forEach(card => {
          const match = !query || card.text.includes(query) || (root.dataset.surDirectory !== 'brands' && group.heading.includes(query));
          card.element.hidden = !match; if (match) { visible++; count++; }
        });
        group.element.hidden = visible === 0 && !(isCategory && headingMatch);
        const heading = group.element.querySelector('h2[id]');
        if (heading) root.querySelectorAll('.sur-az a').forEach(a => { if (a.getAttribute('href') === '#' + heading.id) a.hidden = visible === 0; });
      });
      status.textContent = count + ' de ' + total + totalText;
      empty.hidden = count !== 0;
      search.href = root.dataset.searchUrl + '?type=product&q=' + encodeURIComponent(input.value.trim());
      clear.disabled = !input.value;
    };
    let timer;
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(update, 120); });
    clear.addEventListener('click', () => { clearTimeout(timer); input.value = ''; update(); input.focus(); });
    controls.append(label, input, clear, status, empty);
    root.insertBefore(controls, root.querySelector('.sur-az') || groups[0].element);
    root.dataset.surReady = 'true'; update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
